import type { CragRoute } from '../../../types/crag-route';
import { nearbyRouteNumbers, parseWholeNumber, type NearbyRouteNumber } from './route-length';

/** Matches `Route::MAX_BOLTS` — the server refuses more. */
export const MAX_ROUTE_BOLTS = 200;

/** The bolts field as the server wants it: see `parseRouteLength`, whose rules these are. */
export function parseRouteBolts(typed: string): { value: number | null; invalid: boolean } {
  return parseWholeNumber(typed, MAX_ROUTE_BOLTS);
}

/**
 * The bolts of the two routes immediately either side of this one: on the same
 * height of rock a line is usually bolted alike. See `nearbyRouteLengths`.
 */
export function nearbyRouteBolts(
  routes: CragRoute[],
  selectedRouteId: string | null
): NearbyRouteNumber[] {
  return nearbyRouteNumbers(routes, selectedRouteId, (route) => route.bolts);
}
